import * as ROUTES from 'routes';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { NavItem } from '@ihsm/ui-shared';
import { useActions, useAppSelector } from 'state/store';
import { ReactComponent as Reports } from '../assets/report_icon.svg';
import { ReactComponent as Jobs } from '../assets/jobs.svg';
import { ReactComponent as Portfolios } from '../assets/analysis.svg';
import { ReactComponent as Dashboard } from '../assets/dashboard.svg';
import { ReactComponent as MarketData } from '../assets/chart-scatter.svg';
import { ReactComponent as Metrics } from '../assets/metrics_icon.svg';

export const useNavBarItems = (): NavItem[] => {
  const { push } = useHistory();
  const { setConfirmationModal, setModalRedirect } = useActions();
  const isModalVisible = useAppSelector(
    (state) => state.customReportDataState.isExitConfirmationVisible
  );

  const isEditReport = useRouteMatch({ path: ROUTES.REPORTS_EDIT_REPORT });
  const isNewReport = useRouteMatch({ path: ROUTES.REPORTS_NEW_REPORT });

  const routeChange = (route: string) => {
    if (isEditReport || isNewReport || !isModalVisible) {
      setModalRedirect(route);
      setConfirmationModal(true);
      return;
    }

    push(route);
  };

  const NAVIGATION_ITEMS: NavItem[] = [
    {
      headerText: 'Dashboard',
      headerIcon: Dashboard,
      path: ROUTES.DASHBOARD,
      onClick: () => routeChange(ROUTES.DASHBOARD),
    },
    {
      headerText: 'Jobs',
      headerIcon: Jobs,
      path: ROUTES.JOBS,
      onClick: () => routeChange(ROUTES.JOBS),
    },
    {
      headerText: 'Portfolios',
      headerIcon: Portfolios,
      path: ROUTES.PORTFOLIOS,
      onClick: () => routeChange(ROUTES.PORTFOLIOS),
    },
    {
      headerText: 'Reports',
      headerIcon: Reports,
      path: ROUTES.REPORTS,
      onClick: () => routeChange(ROUTES.REPORTS),
    },
    {
      headerText: 'Market Data',
      headerIcon: MarketData,
      path: ROUTES.MARKET_DATA,
      onClick: () => routeChange(ROUTES.MARKET_DATA),
    },
    {
      headerText: 'Metrics',
      headerIcon: Metrics,
      path: ROUTES.METRICS,
      onClick: () => routeChange(ROUTES.METRICS),
    },
  ];

  return NAVIGATION_ITEMS;
};
